import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { useLocalQuery } from '../useLocalQuery';
import {
  PaymentErrorQuery,
  PaymentErrorQuery_paymentError as PaymentError
} from '../../generated/types/PaymentErrorQuery';

export const typeDefs = gql`
  type PaymentError {
    error: String
  }
`;

export const PAYMENT_ERROR_QUERY = gql`
  query PaymentErrorQuery {
    paymentError @client {
      error
    }
  }
`;

export const PAYMENT_ERROR_DEFAULTS: PaymentError = {
  __typename: 'PaymentError',
  error: ''
};

export const usePaymentError = () => {
  const { data, error, client } = useLocalQuery<PaymentErrorQuery>(PAYMENT_ERROR_QUERY);

  const setPaymentError = useCallback(
    (error: string | null) =>
      client.writeQuery<PaymentErrorQuery>({
        query: PAYMENT_ERROR_QUERY,
        data: { paymentError: { __typename: 'PaymentError', error } }
      }),
    [client]
  );

  if (error) throwQueryError(error);

  return {
    paymentError: data?.paymentError?.error ?? null,
    setPaymentError
  };
};
